import { render, staticRenderFns } from "./GradeTag.vue?vue&type=template&id=7ebd6041&scoped=true&"
import script from "./GradeTag.vue?vue&type=script&lang=js&"
export * from "./GradeTag.vue?vue&type=script&lang=js&"
import style0 from "./GradeTag.vue?vue&type=style&index=0&id=7ebd6041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebd6041",
  null
  
)

export default component.exports